import { TContent } from '@/types/Content.types';

// An article's `details.sections` mixes two things: an optional untitled lead section
// (rendered as the "Full Description") and the titled chapters after it. Splitting that
// apart once keeps the reader components from re-deriving it.

export type TReaderSubsection = { _id?: string; title?: string; text?: string; imageUrl?: string | null };
export type TReaderSection = TReaderSubsection & { subsections?: TReaderSubsection[] };

export type TReaderDetails = {
  body?: string;
  sections?: TReaderSection[];
  source?: string;
  fullDescription?: string;
  mux?: { playbackId?: string; status?: string; thumbnailUrl?: string };
  youtube?: { videoId?: string };
};

export const readReaderDetails = (content: TContent): TReaderDetails => (content.details ?? {}) as TReaderDetails;

export const splitArticleSections = (content: TContent, details: TReaderDetails) => {
  const sections = details.sections ?? [];
  const hasLead = sections.length > 0 && !sections[0].title?.trim();
  const lead = hasLead ? sections[0] : undefined;
  const chapters = (hasLead ? sections.slice(1) : sections).filter((s) => s.title?.trim() || s.text?.trim());

  return { lead, chapters, fullDescription: lead?.text || content.description };
};

export const scrollToChapter = (index: number) =>
  document.getElementById(`chapter-${index}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
